import React from 'react';
import { PaperPage } from '../common/PaperPage';
import { ExternalVouchersTable } from './ExternalVouchersTable';

export const ExternalVouchersPage = () => (
  <PaperPage>
    <ExternalVouchersTable />
  </PaperPage>
);
